<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top z-depth-0"
    style="z-index: 10;"
  >
    <router-link to="/" class="navbar-brand ">
      <img src="@/assets/image/logs.gif" height="42" alt="Dawini dz" />
    </router-link>
    <button
      class="navbar-toggler d-lg-none"
      type="button"
      data-toggle="collapse"
      data-target="#collapsibleNavId"
      aria-controls="collapsibleNavId"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="collapsibleNavId">
      <ul class="navbar-nav ml-auto mt-2 mt-lg-0 text-center">
        <li class="nav-item">
          <a class="nav-link" href="#overview">Overview</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#services">Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#articles">Blog</a>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/store">Boutique</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#temoignage">temoignage</a>
        </li>
        <li class="nav-item dash" v-if="isLogged">
          <router-link class="nav-link" to="/dashboard/home"
            >Dashboard</router-link
          >
        </li>

        <li class="nav-item avatar dropdown prof" v-if="isLogged">
          <a
            class="nav-link dropdown-toggle"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              src="@/assets/image/user.png"
              class="rounded-circle z-depth-0"
              alt="avatar image"
              id="profileImg"
              width="35"
              height="35"
          /></a>

          <div
            class="dropdown-menu dropdown-primary"
            aria-labelledby="navbarDropdownMenuLink"
          >
            <a class="dropdown-item disabled" href="store/mystore.php"
              >mon magasin</a
            >
            <div class="dropdown-divider"></div>
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="signOut()"
              id="Deconnexion"
              >Deconnexion</a
            >
          </div>
        </li>

        <li class="nav-item sisi" id="sisi" v-if="!isLogged">
          <router-link class="nav-link" to="/login"
            ><input
              name=""
              class="btn btn-primary si"
              type="button"
              value="Connexion ou inscription"
              style="padding: 3px 6px;"
          /></router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { auth } from "@/firebase";

export default {
  data() {
    return {
      doc: [],
      isLogged: false,
      currentUser: null
    };
  },
  methods: {
    signOut() {
      auth.signOut().then(() => {
        location.reload();
      });
    }
  },
  created() {
    auth.onAuthStateChanged(user => {
      if (user) {
        (this.isLogged = true), (this.currentUser = user.email);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.bg-dark {
  background-color: #000098 !important;
  line-height: 35px !important;
}
.navbar-dark .navbar-nav .nav-link {
  color: white;
}
/* dropdown profile */
.dropdown-menu {
  left: auto;
  right: 0;
}
.dropdown-item {
  padding: 0px 20px !important;
}
.dropdown-divider {
  margin: 0;
}
.dropdown-item:focus,
.dropdown-item:hover {
  background-color: #000098 !important;
  color: #fff !important;
}

@media (max-width: 1199.98px) {
  .dropdown-menu {
    left: 0 !important;
    right: 0 !important;
  }
}
li.nav-item {
  margin-bottom: 0;
}
.media .avatar {
  width: 64px;
}
.si .sup {
  font-size: 14px;
  line-height: 16px;
}
</style>